import { render, staticRenderFns } from "./EditTransactionType.vue?vue&type=template&id=5f00e8c6&"
import script from "./EditTransactionType.vue?vue&type=script&lang=js&"
export * from "./EditTransactionType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports